import React from 'react';
import { Navigate, Outlet} from 'react-router-dom'
import { useAuth } from '../hooks/useAuth';

export default function PrivateRoute(params) {
  const auth = useAuth()

  const user = auth.logado
  
  return (
    user ? <Outlet/> : <Navigate to={"/login"}/>
  )
};
